import { Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { checkRoles } from "../../Utils/helper";
import "./styles.css";
import { useEffect } from "react";

const SideNav = ({ isVisible, setVisibility }) => {
  const toggleSidebar = () => setVisibility(!isVisible);

  return (
    <>
      <Sidebar
        id="header"
        collapsed={!isVisible}
        defaultCollapsed={true}
        width="300px"
        collapsedWidth="150px"
      >
        <Menu
          closeOnClick={true}
          menuItemStyles={{
            button: {
              ["&.active"]: {
                backgroundColor: "#13395e",
                color: "#b6c8d9",
              },
            },
          }}
        >
          <SubMenu
            icon={<ion-icon name="hourglass-outline"></ion-icon>}
            label="Hours"
            defaultOpen={true}
          >
            <MenuItem
              icon={<ion-icon name="time-outline"></ion-icon>}
              component={<Link to="/hours" />}
            >
              Upload Hours
            </MenuItem>
            <MenuItem
              icon={<ion-icon name="calendar-outline"></ion-icon>}
              component={<Link to="/users/uploads" />}
            >
              View Hours
            </MenuItem>
          </SubMenu>

          <SubMenu
            icon={<ion-icon name="bag-outline"></ion-icon>}
            label="Business"
          >
            <MenuItem
              icon={<ion-icon name="cart-outline"></ion-icon>}
              component={<Link to="/orders" />}
            >
              Orders
            </MenuItem>
            <MenuItem
              icon={<ion-icon name="bag-handle-outline"></ion-icon>}
              component={<Link to="/purchaseOrders" />}
            >
              PO Requests
            </MenuItem>
            {checkRoles(5) && (
              <>
                <MenuItem
                  icon={<ion-icon name="location"></ion-icon>}
                  component={<Link to="/deliveryLocations" />}
                >
                  Delivery Locations
                </MenuItem>
                <MenuItem
                  icon={<ion-icon name="card"></ion-icon>}
                  component={<Link to="/pCards" />}
                >
                  PCards
                </MenuItem>
                <MenuItem
                  icon={<ion-icon name="person"></ion-icon>}
                  component={<Link to="/supplierList" />}
                >
                  Supplier List
                </MenuItem>
              </>
            )}
          </SubMenu>

          {checkRoles(3) && (
            <>
              <MenuItem
                icon={<ion-icon name="people-outline"></ion-icon>}
                component={<Link to="/users" />}
              >
                User List
              </MenuItem>

              <SubMenu
                icon={<ion-icon name="receipt-outline"></ion-icon>}
                label="Reports"
              >
                <MenuItem
                  icon={<ion-icon name="person-outline"></ion-icon>}
                  component={<Link to="/reports/users" />}
                >
                  Users
                </MenuItem>
                <MenuItem
                  icon={<ion-icon name="reader-outline"></ion-icon>}
                  component={<Link to="/reports/projects" />}
                >
                  Projects
                </MenuItem>
                <MenuItem
                  icon={<ion-icon name="bar-chart-outline"></ion-icon>}
                  component={<Link to="/reports/cells" />}
                >
                  Cells
                </MenuItem>
              </SubMenu>

              <SubMenu
                icon={<ion-icon name="location-outline"></ion-icon>}
                label="Locations"
              >
                <MenuItem
                  icon={<ion-icon name="grid-outline"></ion-icon>}
                  component={<Link to="/workCenters" />}
                >
                  Work Centers
                </MenuItem>
                <MenuItem
                  icon={<ion-icon name="business-outline"></ion-icon>}
                  component={<Link to="/companies" />}
                >
                  Companies
                </MenuItem>
              </SubMenu>
            </>
          )}

          <MenuItem
            icon={<ion-icon name="layers-outline"></ion-icon>}
            component={<Link to="/projects" />}
          >
            Projects
          </MenuItem>

          <MenuItem
            icon={<ion-icon name="desktop-outline"></ion-icon>}
            component={<Link to="/dashboard" />}
          >
            Dashboard
          </MenuItem>
        </Menu>
      </Sidebar>
    </>
  );
};

export default SideNav;
